import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=715b6996&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Notification.vue?vue&type=style&index=0&id=715b6996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b6996",
  null
  
)

export default component.exports